import { measureLineLength } from './measureLineLength'

export const measureTotalLineLength = coordinates => {
  let totalLength = 0

  coordinates.forEach((xs, index) => {
    const ys = coordinates[index + 1]
    ys && (totalLength = totalLength + measureLineLength(xs, ys))
  })

  return totalLength
}
